import axios from 'axios'

export default {
  methods: {
    initCancelToken(token) {
      // Cancel previous request
      token?.cancel();
      return axios.CancelToken.source();
    },

    cancelCancelToken(token, message = 'Request cancelled') {
      token?.cancel(message);
    }
  }
}
